export { default } from './Home24';
